<template>
	<h1 class="font-bold text-4xl text-white">
		<slot></slot>
	</h1>
</template>

<style lang="scss" scoped>
h1 {
	font-family: "Roboto Condensed";
}
</style>
